import React from 'react';
import Avatar from './Avatar';

interface StaffMember {
  id: number;
  name: string;
  role: string;
  avatar?: string;
  contact?: string;
}

interface ServerStaffProps {
  staff: StaffMember[];
  className?: string;
}

const ServerStaff: React.FC<ServerStaffProps> = ({ 
  staff,
  className = ''
}) => {
  if (!staff || staff.length === 0) {
    return null;
  }

  return (
    <div className={`bg-gray-800 rounded-lg shadow-lg p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">Server Staff</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {staff.map(member => (
          <div 
            key={member.id} 
            className="flex items-center p-3 bg-gray-750 rounded-lg hover:bg-gray-700 transition"
          >
            <Avatar src={member.avatar} alt={member.name} size="md" className="mr-3" />
            <div>
              <div className="font-bold">{member.name}</div>
              <div className="text-sm text-blue-400">{member.role}</div>
              {member.contact && (
                <div className="text-xs text-gray-400 mt-1">{member.contact}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServerStaff;